import React, { FC } from 'react';
import Button from 'common/components/base/button';
import { Modal, ModalBody, ModalFooter } from 'common/components/base/modal';
import MessageModal from '../message-modal';
import { ButtonLabel, EntityActions } from 'common/enums';
import {
    DELETE_POPUP_SUMMARY_PART1,
    DELETE_POPUP_SUMMARY_PART2,
    DELETE_POPUP_TITLE
} from 'common/config';

type DeleteConfirmationProps = {
    isVisible: boolean;
    onClose: () => void;
    onDelete: () => void;
};

const DeleteConfirmation: FC<DeleteConfirmationProps> = ({ isVisible, onClose, onDelete }) => {
    const handleDelete = () => {
        onDelete();
    };

    const handleCancel = () => {
        onClose();
    };
    const popupDetails = {
        title: DELETE_POPUP_TITLE,
        text: `${DELETE_POPUP_SUMMARY_PART1} this record. ${DELETE_POPUP_SUMMARY_PART2}`,
        type: EntityActions.Delete
    };

    return (
        <MessageModal
            isVisible={isVisible}
            headerName={popupDetails.title}
            message={popupDetails.text}
            isSecondaryButtonVisible={true}
            primaryButton={ButtonLabel.Ok}
            secondaryButton={ButtonLabel.Cancel}
            onPrimaryAction={handleDelete}
            onSecondaryAction={handleCancel}
        />
        // <Modal className="delete-container" show={isVisible} onClose={handleCancel}>
        //     <ModalBody>Are you sure you want to delete?</ModalBody>
        //     <ModalFooter>
        //         <Button variant="primary" onClick={handleDelete}>
        //             Confirm
        //         </Button>
        //         <Button variant="secondary" type="button" onClick={handleCancel}>
        //             Cancel
        //         </Button>
        //     </ModalFooter>
        // </Modal>
    );
};

export default DeleteConfirmation;
